import { AGENT_HUB_ADMIN_BASE_PATH } from '@lumapps/agent-hub/constants';
import type { Agent } from '@lumapps/agent-hub/types';
import { Route, AppId, createEntityManagementRoutes } from '@lumapps/router';

const { baseRoute, createRoute, editRoute, getEditRoute } = createEntityManagementRoutes({
    /** Temporary url as for now the page will be for all agents */
    slug: `${AGENT_HUB_ADMIN_BASE_PATH}/agents`,
    id: 'agent-hub-agents',
    appId: AppId.backOffice,
});

export const getAgentsEditRoute = (agentId: Agent['id']): Route => getEditRoute(agentId);

export { baseRoute as agentsBaseAdminRoute, editRoute as agentsEditAdminRoute, createRoute as agentsCreateAdminRoute };
